import { Alert, AutoComplete, Button, Form, Select } from 'antd'
import React, { useCallback, useMemo, useState } from 'react'
import { useCreateEmployeeMutation, useGetCompaniesQuery } from '../../api/company.api'
import { useMyContext } from '../../context/context'
import useConf from '../../hooks/useConf'
import useTranslations from '../../hooks/useTranslations'
import HTML from '../../components/HTML'
import { indexes, indexesArr } from './indexes'

const CompanySiren = ({ toCreate, toList }) => {
  const [find, setFind] = useState(false)
  const [siren, setSiren] = useState('')
  const [country, setCountry] = useState('FR')
  const { domainId, userId } = useMyContext()
  const { companyIndexSize, companyIndexLabel, COMPANIES_INDEX_HTML, FO_INDEX_INTER } = useConf()
  const { t } = useTranslations()

  const { data: companies } = useGetCompaniesQuery({ domainId, siren, country })
  const [createEmployee] = useCreateEmployeeMutation()

  const index = useMemo(() => indexes[country], [country])

  const onSelect = async (_, { data }) => {
    await createEmployee({ domainId, body: { userId, companyId: data.id } }).unwrap()
    toList(data.id)
  }

  const onCreate = useCallback(
    v => {
      const f = companies?.find(f => f.siren === v.siren)
      if (f) {
        setFind(f)
      } else {
        toCreate(v)
      }
    },
    [companies, toCreate]
  )

  return (
    <div>
      <div style={{ height: 16 }} />
      <Button type="primary" onClick={toList}>
        {t('BACK')}
      </Button>
      <HTML value={COMPANIES_INDEX_HTML} />

      {find ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <Alert
            message={`Cet identifiant est déjà utilisé par la société suivante : ${find.name} (${find.siren}). Voulez-vous choisir cette société ou recommencer ?`}
            type="info"
            showIcon
          />
          <div style={{ display: 'flex', gap: 8 }}>
            <Button style={{ flexGrow: 1 }} onClick={() => setFind(false)}>
              Recommencer
            </Button>
            <Button style={{ flexGrow: 1 }} type="primary" onClick={() => toCreate(find)}>
              Choisir cette société
            </Button>
          </div>
        </div>
      ) : (
        <Form onFinish={onCreate} layout="vertical">
          {FO_INDEX_INTER ? (
            <>
              <Form.Item
                label={t('SELECT_COUNTRY')}
                name="country"
                rules={[{ required: true, message: 'Ce champ est obligatoire' }]}
                initialValue="FR"
              >
                <Select options={indexesArr.map(m => ({ label: m.country, value: m.value }))} value={country} onChange={setCountry} />
              </Form.Item>
              <Form.Item
                label={`${index.label}`}
                name="siren"
                rules={[
                  { pattern: index.pattern, message: 'Mauvais format' },
                  { required: true, message: 'Ce champ est obligatoire' },
                ]}
              >
                <AutoComplete
                  options={
                    siren
                      ? companies.map(company => ({ label: `${company.name} (${company.siren})`, value: company.id, data: company }))
                      : []
                  }
                  onSelect={onSelect}
                  onSearch={setSiren}
                  placeholder={`${t('EXAMPLE')} : ${index.example}`}
                />
              </Form.Item>
            </>
          ) : (
            <Form.Item
              label={`${companyIndexLabel || 'SIREN de la société'} (la taille doit être de ${companyIndexSize || 9})`}
              name="siren"
              rules={[
                { len: companyIndexSize || 9, message: `La taille doit être de ${companyIndexSize || 9}` },
                { pattern: new RegExp('^[0-9]+$'), message: 'Le champ doit contenir uniquement des chiffres' },
                { required: true, message: 'Ce champ est obligatoire' },
              ]}
            >
              <AutoComplete
                // options={
                //   siren ? companies.map(company => ({ label: `${company.name} (${company.siren})`, value: company.id, data: company })) : []
                // }
                // onSelect={onSelect}
                maxLength={companyIndexSize || 9}
                onSearch={setSiren}
              />
            </Form.Item>
          )}
          <div style={{ display: 'flex', alignItems: 'flex-end', flexDirection: 'column' }}>
            <Button type="primary" htmlType="submit">
              {t('NEXT')}
            </Button>
          </div>
        </Form>
      )}
    </div>
  )
}

export default CompanySiren
